export const COMPANY_NAME = "SafeGrow";
export const COMPANY_EMAIL = "support@safegrow.co";
export const COMPANY_WEBSITE = "https://www.safegrow.co";
export const LOGIN_URL = "https://user.safegrow.co/";

export const resolve = (text) =>
  text
    ?.replace(/\{COMPANY_NAME\}/g, COMPANY_NAME)
    ?.replace(/\{COMPANY_EMAIL\}/g, COMPANY_EMAIL) ?? "";
